import React from 'react'
import { NavLink } from 'react-router-dom'
import { FiLock } from 'react-icons/fi'

const focusRing =
  'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ember focus-visible:tw-ring-offset-2'

function PageHeaderTab({ tab }) {
  const base = `tw-inline-flex tw-items-center tw-gap-1 tw-whitespace-nowrap tw-rounded-[10px] tw-text-[14px] tw-font-medium ${focusRing}`

  if (tab.disabled) {
    return (
      <span aria-disabled='true' className={`${base} tw-cursor-not-allowed tw-text-disabled`}>
        {tab.label}
      </span>
    )
  }

  if (tab.locked) {
    return (
      <NavLink
        to={tab.to}
        aria-disabled='true'
        title='Upgrade your plan to unlock'
        className={`${base} tw-text-inkFaint hover:tw-text-ink`}
      >
        <FiLock aria-hidden='true' className='tw-h-3.5 tw-w-3.5' />
        {tab.label}
      </NavLink>
    )
  }

  return (
    <NavLink
      to={tab.to}
      end={tab.end}
      className={({ isActive }) =>
        `${base} ${isActive ? 'tw-text-ember' : 'tw-text-inkSoft hover:tw-text-ink'}`
      }
    >
      {tab.label}
    </NavLink>
  )
}

function PageHeader({ title, tabs, actions }) {
  return (
    <div className='tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-3'>
      <h1 className='tw-font-heading tw-text-[26px] tw-font-extrabold tw-leading-tight tw-text-ink'>
        {title}
      </h1>
      {tabs?.length > 0 && (
        <nav aria-label={`${title} sections`} className='tw-min-w-0 tw-max-w-full tw-overflow-x-auto'>
          <ul className='tw-flex tw-items-center tw-gap-5 tw-p-1'>
            {tabs.map((tab) => (
              <li key={`${tab.label}-${tab.to}`}>
                <PageHeaderTab tab={tab} />
              </li>
            ))}
          </ul>
        </nav>
      )}
      {actions && <div className='tw-ml-auto tw-flex tw-items-center tw-gap-3'>{actions}</div>}
    </div>
  )
}

export default PageHeader
